@if (isLoading()) {
    <div class="mat-spinner"><mat-spinner></mat-spinner></div>
}

@if (!isLoading()) {
    <mat-sidenav-container class="nav-container">
        <!--#region Navigation menu -->
        @if (isLoggedIn() && !onChangePasswordScreen) {
            <mat-sidenav
                #sidenav
                [mode]="navService.isNavFixed() && !navService.isMobile() ? 'side' : 'over'"
                [opened]="navService.isNavOpen()"
                (openedChange)="navService.toggleNavOpen($event)"
                (mouseleave)="navService.toggleNavOpen(navService.isNavFixed())"
                class="no-print"
            >
                <pcg-mat-side-nav [user]="user" id="sidenav" class="no-print"></pcg-mat-side-nav>
            </mat-sidenav>
        }
        <!--#endregion-->
        <!-- Rest of the site -->
        <mat-sidenav-content [ngClass]="{ darker: navService.isNavOpen() }">
            <!--#region Nav drawer -->
            @if (!navService.isMobile() && !navService.isNavFixed() && isLoggedIn() && !onChangePasswordScreen) {
                <nav class="nav-drawer no-print">
                    <div class="nav-drawer-image">
                        <button
                            class="d-flex align-items-center justify-content-center mt-2 fixed-toggle-btn"
                            (click)="navService.toggleNavFixed(true)"
                        >
                            <fa-icon [icon]="faIconName.faArrowRight" class="fa-lg"></fa-icon>
                        </button>
                    </div>
                    <a class="drawer-icon" (click)="navService.homeButtonClick()">
                        <fa-icon
                            class="drawer-icon pointer"
                            [icon]="faIconName?.faHouse"
                            [class.active-drawer-item]="navService.selectedMainNav() === 'Home'"
                        ></fa-icon>
                    </a>
                    @for (nav of navService.navRoutes(); track nav) {
                        @if (navService.canViewNav(nav) && nav?.icon && nav?.name != '') {
                            <a class="drawer-icon pointer" [routerLink]="nav?.href ?? nav?.path">
                                <fa-icon
                                    [icon]="nav?.icon"
                                    [class.active-drawer-item]="nav?.name === navService.selectedMainNav()"
                                ></fa-icon>
                            </a>
                        }
                    }
                    <fa-icon
                        [icon]="faIconName.faUser"
                        class="drawer-icon pointer"
                        [class.active-drawer-item]="navService.selectedMainNav() === 'profile'"
                        (click)="takeToMyProfile()"
                    ></fa-icon>
                    <fa-icon
                        class="drawer-icon fa-lg pointer"
                        [icon]="faIconName.faSwap"
                        (click)="openChangeEventModal()"
                    ></fa-icon>
                </nav>
            }
            <!--#endregion-->
            <!--#region Everything else -->
            <div [ngClass]="!isLoggedIn() ? '' : navService.isNavFixed() ? 'left-shift-fixed' : 'left-shift'">
                <pcg-header
                    id="mainTopHeader"
                    (hamburgerClick)="navService.toggleNavOpen($event)"
                    [tabPanel]="tabPanel"
                    [onChangePasswordScreen]="onChangePasswordScreen"
                ></pcg-header>
                <div
                    [ngClass]="!isLoggedIn() ? '' : navService.isNavFixed() ? 'top-shift-fixed' : 'top-shift'"
                    class="mb-3"
                >
                    <div role="main" class="main-container">
                        <mat-tab-nav-panel #tabPanel class="container">
                            <router-outlet></router-outlet>
                        </mat-tab-nav-panel>
                    </div>
                    <pcg-system-message></pcg-system-message>
                    <pcg-spinner></pcg-spinner>
                </div>
            </div>
            <!--#endregion-->
            @if (!navService.isMobile()) {
                <div class="footer-ctnr no-print">
                    <div class="footer">
                        A Subsidiary of&nbsp;
                        <a href="https://fdepcs.com/" target="_blank">HOMER</a>
                        &nbsp;|&nbsp; System by&nbsp;
                        <a rel="noreferrer noopener" href="http://www.paulconsultinggroup.com" target="_blank"
                            >Paul Consulting Group</a
                        >
                        &nbsp;|&nbsp;
                        <a href="assets/privacy-policy.html" target="_blank">Privacy Policy</a>
                        &nbsp;|&nbsp;
                        <a class="blue-link" href="/privacy-policy" target="_blank" class="blue-link">Privacy Policy</a>
                        &nbsp;|&nbsp;
                        @if (isLoggedOn) {
                            <span id="versionHistory">
                                &nbsp;|&nbsp;
                                <div class="blue-link" (click)="toReleaseNotes()">Release Notes</div>
                                &nbsp;|&nbsp;
                                <a
                                    rel="noreferrer noopener"
                                    href="https://apps.apple.com/us/app/emit-florida/id6469525912"
                                    target="_blank"
                                    >iOS App Store</a
                                >
                                &nbsp;|&nbsp;
                                <a
                                    rel="noreferrer noopener"
                                    href="https://play.google.com/store/apps/details?id=com.fdepcs.emit.twa"
                                    target="_blank"
                                    >Google Play Store</a
                                >
                            </span>
                        }
                    </div>
                </div>
            }
            @if (navService.isMobile() && isLoggedIn()) {
                <div class="no-print mobile-footer">
                    <div class="footer-icon p-1" (click)="takeToHome()">
                        <div [class]="isOnHome ? 'on-icon-page' : ''">
                            <fa-icon [icon]="faIconName.faHouse"></fa-icon>
                            <div class="itty-bitty-font">Home</div>
                        </div>
                    </div>
                    <div class="footer-icon p-1" (click)="takeToOrgs()">
                        <div [class]="isOnInventories ? 'on-icon-page-inventory' : ''">
                            <fa-icon [icon]="faIconName.faBuildingColumns"></fa-icon>
                            <div class="itty-bitty-font">Organizations</div>
                        </div>
                    </div>
                    <div class="footer-icon p-1" (click)="takeToMyProfile()">
                        <div [class]="isOnProfile ? 'on-icon-page' : ''">
                            <fa-icon [icon]="faIconName.faUser"></fa-icon>
                            <div class="itty-bitty-font">Profile</div>
                        </div>
                    </div>
                    <div class="footer-icon p-1" (click)="openHelp()">
                        <div [class]="isOnHelp ? 'on-icon-page' : ''">
                            <fa-icon [icon]="faIconName.faQuestionCircle"></fa-icon>
                            <div class="itty-bitty-font">Help</div>
                        </div>
                    </div>
                </div>
            }
        </mat-sidenav-content>
    </mat-sidenav-container>
}

<ng-template #modalChangeEvent let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Change Event</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <select
            #selectEvent
            class="form-control"
            (change)="changeEvent(selectEvent.value)"
            ngDefaultControl
            [(ngModel)]="currentEventId"
            [ngModelOptions]="{ standalone: true }"
        >
            @for (item of eventItems; track item) {
                <option [value]="item.value" class="form-control">
                    {{ item.text }}
                </option>
            }
        </select>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-cancel btn-lg" (click)="modal.dismiss()">Cancel</button>
        <button type="button" class="btn btn-save btn-lg" (click)="saveChangeEvent(modal)">Change Event</button>
    </div>
</ng-template>
